import { Button, useMediaQuery } from '@mui/material'
import { When } from 'react-if'
import Chip from 'Theme/Chip'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import { BREAKPOINT_MIN_MD, BREAKPOINT_MIN_SM } from 'Theme/stylesUtil'
import { getTotalCount } from 'utils/total-count-utils'

export const ButtonBookmark = ({ isBookmarked, totalBookmarks, disabled, onClick, type, noLink = false }) => {
  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)

  return (
    <Button
      variant="contained"
      color="secondary"
      disabled={disabled}
      sx={(theme) => ({
        gap: isBiggerThanSMScreen ? '8px' : '4px',
        fontSize: isBiggerThanSMScreen ? '14px' : '12px !important',
        maxWidth: noLink ? 'unset' : '190px',
        padding: '8px 20px',
        '&:hover': { background: theme.palette.secondary.light },
        [theme.breakpoints.down('xsm')]: {
          '& .MuiButton-startIcon': { margin: 0 },
          '& .MuiButton-endIcon': { margin: 0 },
        },
      })}
      startIcon={
        !noLink && (
          <FAIcon
            iconClassName={isBookmarked ? FA_ICONS.BOOKMARK : FA_ICONS.BOOKMARK_EMPTY}
            boxSize={isBiggerThanSMScreen ? 24 : 16}
          />
        )
      }
      endIcon={
        noLink && (
          <FAIcon
            iconClassName={FA_ICONS.INFO}
            boxSize={isBiggerThanSMScreen ? 24 : 16}
          />
        )
      }
      onClick={onClick}
    >
      {isBiggerThanMDScreen && (noLink ? `No ${type.slice(0, -1)} link` : 'Bookmark')}
      <When condition={isBiggerThanSMScreen && !!totalBookmarks}>
        <Chip
          label={getTotalCount(totalBookmarks)}
          size="small"
          color="secondary"
          style={{ background: '#FFFFFF20' }}
        />
      </When>
    </Button>
  )
}
